//
//
//
//
var script = {
  name: 'Blockquote',
  props: ['node', 'view']
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/RichTextEditor/custom-extensions/renderers/Blockquote.vue_rollup-plugin-vue=script.js